module.exports = __webpack_public_path__ + "img/FengShuiDragon_EGM.c2e8b0ed.jpg";